import PubSub from "pubsub-js";

import PubSubTopics from "../constants/pubSubTopics";
import { isNativeCommsInstalled, nativeCommsBroadcastMessageTypes } from "../nativeComms";

const dialogReturnMessageForType = type => {
  switch (type) {
    case nativeCommsBroadcastMessageTypes.SHOW_YES_NO_CANCEL_DIALOG:
      return PubSubTopics.yesNoCancelPromptResult;
    case nativeCommsBroadcastMessageTypes.SHOW_YES_NO_DIALOG:
      return PubSubTopics.yesNoPromptResult;
    case nativeCommsBroadcastMessageTypes.SHOW_OK_CANCEL_DIALOG:
      return PubSubTopics.okCancelPromptResult;
    case nativeCommsBroadcastMessageTypes.SHOW_ALERT_DIALOG:
      return PubSubTopics.alertPromptResult;
    default:
      return null;
  }
};

const jsFallbackDialog = type => {
  switch (type) {
    case nativeCommsBroadcastMessageTypes.SHOW_YES_NO_CANCEL_DIALOG:
      return window.confirm;
    case nativeCommsBroadcastMessageTypes.SHOW_YES_NO_DIALOG:
      return window.confirm;
    case nativeCommsBroadcastMessageTypes.SHOW_OK_CANCEL_DIALOG:
      return window.confirm;
    case nativeCommsBroadcastMessageTypes.SHOW_ALERT_DIALOG:
      return window.alert;
    default:
      return null;
  }
};

const showGenericPrompt = (message, dialogType, callback, title = "Aeon Timeline") => {
  if (!isNativeCommsInstalled()) {
    const jsWindowDialogFunction = jsFallbackDialog(dialogType);
    const result = jsWindowDialogFunction(message);
    if (callback) {
      callback(result);
    }
    return;
  }

  // When we get a response back, call the callback with the response
  const subscribeTo = dialogReturnMessageForType(dialogType);
  PubSub.subscribeOnce(subscribeTo, (_msg, data) => {
    // Note: data may be a string (for yesNoCancel) or a boolean (the rest, including alert)
    if (callback) {
      callback(data);
    }
  });

  // And now send an async request to show the necessary dialog
  PubSub.publish(PubSubTopics.sendNativeMessage, {
    msg: dialogType,
    title,
    message
  });
};

// // Example Code: How to use Yes/No/Cancel dialog
// dialogs.yesNoCancelPrompt("Test prompt", "A longer message", result => {
//   switch (result) {
//     case dialogResponses.Yes:
//       console.log(`onCreateNew(): Test Prompt response Yes`);
//       break;
//     case dialogResponses.No:
//       console.log(`onCreateNew(): Test Prompt response No`);
//       break;
//     case dialogResponses.Cancel:
//     default:
//       console.log(`onCreateNew(): Test Prompt response Cancel`);
//       break;
//   }
// });

/**
 * Show a Yes/No/Cancel dialog.
 * Warning: this is asynchronous and non-blocking, put any follow up action into the callback
 * @param {string} message
 * @param {function} callback
 */
const yesNoCancelPrompt = (message, callback, title = "Aeon Timeline") => {
  showGenericPrompt(message, nativeCommsBroadcastMessageTypes.SHOW_YES_NO_CANCEL_DIALOG, callback, title);
};

const yesNoPrompt = (message, callback, title = "Aeon Timeline") => {
  showGenericPrompt(message, nativeCommsBroadcastMessageTypes.SHOW_YES_NO_DIALOG, callback, title);
};

const okCancelPrompt = (message, callback, title = "Aeon Timeline") => {
  showGenericPrompt(message, nativeCommsBroadcastMessageTypes.SHOW_OK_CANCEL_DIALOG, callback, title);
};

const alertPrompt = (message, callback, title = "Aeon Timeline") => {
  showGenericPrompt(message, nativeCommsBroadcastMessageTypes.SHOW_ALERT_DIALOG, callback, title);
};

/**
 * Show a standard Javascript confirmation box.
 * This call is somewhat unsafe, as using the standard JS dialogs instead of the asynchronous
 * ones causes a bug in Windows CEF3 where text fields cannot be focused unless the user clicks
 * out of the window and back in again.
 * So we should avoid its use altogether, but it has been kept for now to be used in a small
 * number of cases where a synchronous call is absolutely essential
 * @param {string} message
 */
const UNSAFE_SYNCHRONOUS_confirmationPrompt = message => {
  return window.confirm(message);
};

// const alertPrompt = message => {
//   return window.alert(message);
// };

export default {
  alertPrompt,
  okCancelPrompt,
  yesNoPrompt,
  yesNoCancelPrompt,
  UNSAFE_SYNCHRONOUS_confirmationPrompt
};
